module.exports = __webpack_public_path__ + "img/motor_no12.aca1329b.jpg";